import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../../types/types';
import { ICardDateHOCProps } from './types';
import { CardDates } from '../../components/CardDates/CardDates';
import { ICardDateEvents, ICardDateFields } from '../../components/CardDates/types';
import { getCard } from '../../../../../../../../store/model/selectors/getCard';
import { onChange } from './events/onChange';
import { getBoardPermissions } from '../../../../../../../../store/model/selectors/getBoardPermissions';
import { TStatus } from 'app/types/model';
import { getCardIsEpic } from '../../../../../../../../store/model/selectors/getCardIsEpic';
import { onOpen } from './events/onOpen';
import { onShowSnackbar } from './events/onShowSnackbar';
import {
    getBoardMetaDefaultDueDateTime
} from '../../../../../../../../store/model/selectors/getBoardMetaDefaultDueDateTime';
import {
    getBoardMetaDefaultStartDateTime
} from '../../../../../../../../store/model/selectors/getBoardMetaDefaultStartDateTime';
import { isEqual } from 'underscore';

const mapStateToProps = () => {

    let cache: ICardDateFields = null;
    const getCache = (
        value: ICardDateFields
    ): ICardDateFields => {
        if (isEqual(value, cache)) {
            return cache;
        }
        cache = value;
        return value;
    };

    return (
        state: IApplicationState,
        props: ICardDateHOCProps
    ): ICardDateFields => {
        const {
            cardId,
            boardId,
            dueDate: dueDateOwn,
            startDate: startDateOwn,
            listId,
            isOpened,
            isShowDue,
            isShowStart,
        } = props;
        const card = getCard(state, cardId);
        if (cardId && !card) return null; // KNB-4355

        if (!cardId) {
            return getCache({
                cardId,
                defaultDueTime: getBoardMetaDefaultDueDateTime(state, boardId),
                defaultStartTime: getBoardMetaDefaultStartDateTime(state, boardId),
                dueDate: dueDateOwn ? dueDateOwn * 1000 : null,
                isMilestone: false,
                isReadonly: !getBoardPermissions(state, boardId).authPermissions.allowEdit,
                processingStatus: null,
                listId,
                startDate: startDateOwn ? startDateOwn * 1000 : null
            });
        } else {
            const {dueDate, startDate, processingStatus, isMilestone, estimate, assignees, status} = card;
            const isTemplates = status === TStatus.STATUS_SERVICE_TEMPLATE;
            return getCache({
                cardId,
                defaultDueTime: getBoardMetaDefaultDueDateTime(state, boardId),
                defaultStartTime: getBoardMetaDefaultStartDateTime(state, boardId),
                dueDate: dueDateOwn ? dueDateOwn * 1000 : undefined,
                isDisabled: getCardIsEpic(state, cardId),
                isHideIcons: !!startDate && !!dueDate && (!!estimate || assignees.length > 2),
                isOpened,
                isMilestone,
                isReadonly: !getBoardPermissions(state, boardId).authPermissions.allowEdit,
                isShowDue,
                isShowStart,
                isTemplates,
                listId,
                processingStatus,
                startDate: startDateOwn ? startDateOwn * 1000 : undefined,
            });
        }
    };
}

const mapDispatchToProps = (
    dispatch: any,
    { cardId, source, onChange: onChangeOwn, setDatesOpened, setOpen }: ICardDateHOCProps
): ICardDateEvents => {
    return {
        onChange: (date, type) => dispatch(onChange(cardId, date, type, source, onChangeOwn)),
        setDatesOpened: setDatesOpened,
        onOpen: () => dispatch(onOpen(!cardId)),
        onShowSnackbar: () => dispatch(onShowSnackbar()),
        setOpen,
    };
};

export const CardDatesHOC = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CardDates);

CardDatesHOC.displayName = 'CardDatesHOC';
